import styled from "styled-components"
import { motion } from "framer-motion"

export const Holder = styled(motion.div)`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: -webkit-fill-available;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
`
export const LeftHolder = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 600px;
`
export const RightHolder = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 600px;
  margin: 2vw;
  &:before {
    position: absolute;
    z-index: -1;
    content: "";
    background-color: #cabec3;
    height: 100%;
    width: 70%;
  }
`
export const PicHolder = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 1.5vw;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
`
export const LogoHolder = styled.div`
  width: 100%;
  background-color: #3a2153;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2vw;
`
export const Logo = styled.img`
  width: 15vw;
`
export const Content = styled.div`
  margin: 0;
  padding: 1.5vw 2vw;
`
export const Title = styled.p`
  width: 100%;
  text-align: center;
  font-size: 1.8vw;
  color: #3e1e50;
  font-weight: 700;
  line-height: 100%;
  margin: 0;
  padding: 0;
  margin-bottom: 0.6em;
`
export const Desc = styled.p`
  width: 100%;
  text-align: left;
  font-size: 0.8vw;
  color: #3e1e50;
  line-height: 140%;
  margin: 0;
  padding: 0;
`
export const Desc2 = styled.p`
  width: 100%;
  text-align: left;
  font-size: 0.6vw;
  color: #3e1e50;
  line-height: 140%;
  margin: 0;
  padding: 0;
`
export const ListHolder = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  gap: 1vw;
`

export const List = styled.ul`
  width: 31%;
  min-width: 200px;
  margin: 1.5vw 0;
  padding: 0;
`
export const ItemTitle = styled.li`
  font-size: 0.8vw;
  color: #3e1e50;
  font-weight: 700;
  line-height: 140%;
  margin: 0;
  padding: 0;
  margin-bottom: 0.5em;
  list-style: none;
`
export const Item = styled.li`
  position: relative;
  font-size: 0.7vw;
  color: #3e1e50;
  line-height: 140%;
  margin: 0;
  padding: 0;
  padding-left: 1em;
  list-style: none;
  margin-bottom: 0.3em;
  &:before {
    content: "–";
    position: absolute;
    left: 0;
    top: 0;
  }
`
export const Pic = styled.img`
  width: 95%;
`
